import React, {useContext} from "react";
import LockIcon from "@assets/icon-picto-lock.svg";

import {CartContext} from "@contexts/Cart.jsx"
import { getFormatedPrice } from "@utility/shopify"
import htmlContent from '@assets/dynamic-checkout-buttons.html'


export default ({ className }) => {

  const {loading, cart} = useContext(CartContext);

  const price = loading ? <span className="skeleton skeleton--text" style="--skeleton-text-width: 20%"></span> : getFormatedPrice(cart.items_subtotal_price);

  return <div className="v-stack gap-4 sm:gap-6" slot="footer">
        <div className="v-stack gap-1">
          <div className="h-stack gap-4 justify-between">
            <span className="cart-total bold">Total</span>
            <span className="cart-total-price bold">{price}</span>
          </div>
          <p className="text-subdued text-sm">Free shipping, taxes calculated at checkout</p>
        </div>
      <form action="/cart" method="POST" className="buy-buttons buy-buttons--compact">
        <a href="/cart" className="button button--xl button--atc" data-no-instant={true}>
          View Cart
        </a>
        <button type="submit" class="button button--xl" name="checkout" is="custom-button">
          <div>
            <div className="text-with-icon justify-center">
              Checkout
              <LockIcon />
            </div>
          </div>
          <span className="button__loader">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </form>
      <div className="dynamic-checkout__buttons--cart" dangerouslySetInnerHTML={ {__html: htmlContent} }></div>
    </div>;
}
